import {SC} from "../helper/ServerCall";

export const userService = {
    storeUser,
    getUser,
    editCustomerUser,
    deleteUser,
    getCurrentUser,
    updatePermission,
    getUsersPagination,
    getOrderUsers,
    updateOrderModerator,
    getCustomerUsersPagination,
    storeCustomerUser,
    editUserProfile,
    changeUserPassword,
    signupCustomer,
    sendRecoveryEmail,
    resetUserPassword,
    getUserProfile,
    storeAdminUser,
    editUser
};

function signupCustomer(userData, userId, model) {
    return SC.postCall("customer/signup", userData);
}

function editUserProfile(userData, model) {
    return SC.putCall("update/profile", userData);
}

function storeUser(userData) {
    return SC.postCall("users", userData);
}

function storeAdminUser(userData) {
    return SC.postCall(`user`, userData);
}

function editUser(userData, id) {
    return SC.postCall(`user/${id}`, userData);
}

function storeCustomerUser(userData) {
    return SC.postCall("user", userData);
}

function getUser(userId) {
    return SC.getCall("user/" + userId);
}

function editCustomerUser(userData, userId, model) {
    return SC.putCall("user/" + userId, userData);
}

function deleteUser(userId) {
    return SC.deleteCall("user/" + userId);
}

function getUsersPagination(page, filter, sort, pageSize) {
    return SC.getCall(
        "user?page=" +
        page +
        "&filter=" +
        filter +
        "&sort=" +
        sort +
        "&pageSize=" +
        pageSize +
        "&model=" +
        'user' +
        `&paginate=${true}`
    );
}

function getCustomerUsersPagination(id, model, filter, page, sort, pageSize) {
    return SC.getCall(
        "user?model_id=" +
        id +
        "&model=" +
        model +
        "&page=" +
        page +
        "&filter=" +
        filter +
        "&sort=" +
        sort +
        "&pageSize=" +
        pageSize +
        "&paginate=" +
        true
    );
}

function getCurrentUser() {
    return SC.getCall("getUsersData");
}

function updatePermission(userId) {
    return SC.getCall("changePrimaryContact/" + userId);
}

function getOrderUsers() {
    return SC.getCall("getAllUsersDoNotHaveAgency");
}

function updateOrderModerator(data, orderId) {
    return SC.putCall("updateOrderDetailsUsers/" + orderId + "/update", data);
}


function changeUserPassword(userId, data) {
    return SC.postCall(`reset/user/${userId}/password`, data);
}

function sendRecoveryEmail(data) {
    return SC.postCall(`send/forgot/password/email`, data);
}

function resetUserPassword(data) {
    return SC.postCall(`reset/forgot/password`, data);
}

function getUserProfile() {
    return SC.getCall(`user/profile`);
}



// WEBPACK FOOTER //
// ./src/services/user.js